


















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ReadDrdPanel extends Vue {
  @Prop({ type: String, required: true })
  title !: string;

  @Prop({ type: Number, default: 20 })
  titleSize !: number;

  @Prop({ type: String, default: 'left' })
  contentTextAlign !: string;

  @Prop({ type: Boolean, default: false })
  expandable !: boolean;

  expanded: number | null = 0;

  collapse(): void {
    this.expanded = null;
  }

  expand(): void {
    this.expanded = 0;
  }

  get titleSizePx(): string {
    return `${this.titleSize}px`;
  }

  get isExpanded(): boolean {
    return this.expanded === 0;
  }
}
